import * as THREE from 'three'
import Experience from '../Experience'

export default class Floor {
  constructor() {
    //setup
    this.experience = new Experience()
    this.scene = experience.scene
    this.resources = experience.resources

    this.setGeometry()
    this.setMaterial()
    this.setMesh()
  }

  setGeometry() {
    this.geometry = new THREE.CircleGeometry(5, 64)
  }
  setMaterial() {
    this.material = new THREE.MeshStandardMaterial({
      color: 'DFDFDE',
    })
  }
  setMesh() {
    this.mesh = new THREE.Mesh(this.geometry, this.material)
    this.mesh.rotation.x = -Math.PI * 0.5
    this.mesh.position.y = -2
    this.mesh.receiveShadow = true
    this.scene.add(this.mesh)
  }
}
